export default class LandscapeLayer extends Phaser.Group {
  constructor(game, data, screenH) {
    super(game);

    this.scrollRatio = data.scroll_ratio;
    this.layerH = screenH;
    this.screenH = screenH;

    // craate images to cover screen
    this.imgs = [];
    let x0 = 0;
    do {
      let img = this.game.make.image(x0, data.y, data.key);
      img.anchor.set(0, 1);
      this.imgs.push(img);
      x0 += img.width;
    } while (x0 < this.game.defaultWidth);

    // add one more image
    let img = this.game.make.image(x0, data.y, data.key);
    img.anchor.set(0, 1);
    this.imgs.push(img);

    // add all images to screen
    for (let i = 0; i < this.imgs.length; i++) {
      this.addChild(this.imgs[i]);
    }
  }

  setScreenHeight(value) {
    this.m_screenH = value;
  }

  scroll(dx, y) {
    this.x -= dx * this.scrollRatio;
    this.y = -y * (this.layerH - this.screenH);

    //
    if (this.x < -this.imgs[0].width) {
      this.x += this.imgs[0].width;
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/game/LandscapeLayer.js